<form [formGroup]="inputForm" class="container">
    <mat-slide-toggle formControlName="Enabled">Account Enabled</mat-slide-toggle>
    <mat-slide-toggle formControlName="Emailverified">Email Verified</mat-slide-toggle>
    <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput formControlName="Email" readonly>
    </mat-form-field>
    <app-group-manager [groups]="groupList" [userGroups]="GroupsUpdated.value" (changes)="onChanges()"></app-group-manager>
    <div>
        <mat-label>Created:</mat-label>
        {{ CreatedDate.value | date: "short" }}
    </div>
    <div>
        <mat-label>Last Modified:</mat-label>
        {{ LastModifiedDate.value | date: "short" }}
    </div>
    <!-- <div class="tabs">
        <app-tab-manager [Tabs]="Tabs.controls"></app-tab-manager>
    </div> -->
</form>



